import { ApiClient } from './ApiClient';

export const getApiClientGeneric = () => new ApiClient();

